
















































































import NonCommodityProductInfoWidget from '@/components/widgets/NonCommodityProductInfoWidget.vue';
import Component from 'vue-class-component';

import SERVICES from '@/container/Services';
import Format from '@/interfaces/Format';
import IocContainer from '@/container/IocContainer';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  filters: {
    euro: formatProvider.euro()
  }
})
export default class ProductInfoWidget extends NonCommodityProductInfoWidget {
  public mounted(): void {
    if (
      (this.sessionState.productCode?.includes(this.product.productCode) &&
        this.sessionState.productCode?.includes('_B2B')) ||
      this.sessionState.productCode?.toUpperCase() === this.product.productCode.toUpperCase()
    ) {
      this.store.dispatch('setNonCommodityProduct', this.product);
      this.$emit('selectProduct', this.product);
    }
  }

  get isSelected(): boolean {
    const selectedProduct = this.store.state.nonCommodityProductData;
    const selectedProductCode = selectedProduct?.productCode.toUpperCase();
    const productCode = this.product.productCode.toUpperCase();

    if (productCode === selectedProductCode) {
      return true;
    }
    if (selectedProductCode.includes(productCode) && selectedProductCode.includes('B2B')) {
      return true;
    }
    return false;
  }

  public get nonCommodityProductPriceBrutto(): number | undefined {
    const selectedVehicleTypeIdentifier = this.thgConfig.selectedVehicleTypeIdentifier;
    return this.nonCommodityProduct.getBasePriceBrutto(selectedVehicleTypeIdentifier, this.thgConfig.selectedYearArray);
  }
}
